import { createFileRoute } from '@tanstack/react-router'

import { RootRoute } from '@/pages/auth/route-entries/password-reset'
import { defaultPasswordResetQuery, passwordResetSchema } from '@/pages/auth/search-schema'

export const Route = createFileRoute('/_auth/login/password-reset/')({
  validateSearch: (search) => passwordResetSchema.catch(defaultPasswordResetQuery).parse(search),

  component: RootRoute,
})
